// @flow

import React from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';

type Props = {
  open: boolean,
  onClose: Function,
  onConfirm: Function,
  periodEndDate: string,
  loading: boolean
};

const DisableAutoRenewDialog = (props: Props) => {
  const { open, onClose, onConfirm, periodEndDate, loading } = props;

  return (
    <Dialog
      aria-labelledby='disable-auto-renew-dialog-title'
      onClose={onClose}
      open={open}
    >
      <DialogTitle id='disable-auto-renew-dialog-title'>Disable Auto-Renew</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          Your subscription will remain active until <b>{periodEndDate}</b>. After that, it will not renew automatically. You can re-enable auto-renew at any time.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button
          color='primary'
          disabled={loading}
          onClick={onConfirm}
          variant='contained'
        >
          {loading ? <CircularProgress size={24} /> : 'Confirm'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DisableAutoRenewDialog;
